"use strict";

angular.module("contartemx.inicio.poliza.nueva", [
	"contartemx",
	"ngTable",
	"ui.router",
	"ui.bootstrap",
	"datePicker",
	"tableTools",
	"loader",
	"angularFileUpload"
])

.controller("PolizaNuevaCtrl", function PolizasController($scope, Upload, $state, $filter, callToWebService, apiCall, fileUploadService, mostrarNotificacion, $uibModal, dateTools) {
	$scope.cuentaSelected = null;
	$scope.selectedRow = -1;
	$scope.disabledC = false;
	$scope.disabledA = false;
	$scope.guardarComprobanteRespuesta = null;
	$scope.TotalCargos = 0;
	$scope.TotalAbonos = 0;
	$scope.pAgregadas = [];
	$scope.ErrorArchivo = false;
	$scope.ShowCategories = false;
	$scope.CopyCuentaMayorSelect = null;
	$scope.ShowSubCategories = true;
	$scope.CategoryChange = false;
	$scope.defaultOpt = { Numero: 0 };
	if($scope.Movil)
		$scope.fechaFactura = new Date();
	else
		$scope.fechaFactura = moment().format('DD/MM/YY');

  const ContarteAPI = new apiCall($scope);

  ContarteAPI.post('ObtenerPantallaNuevaPoliza', {})
    .then(data => {
      if (!data.EsError && data.Respuesta) {
        $scope.CuentasOriginal = data.Respuesta.Cuentas;
        $scope.CuentasMayores = data.Respuesta.CuentasMayores;
        $scope.Monedas = data.Respuesta.Monedas;
        $scope.SeleccionarMonedaDefault();
        $scope.Cuentas = $scope.CuentasOriginal;
      }
    },
      error => {
        mostrarNotificacion.error(error.Mensaje);
      }
    );

	$scope.GetCategories = function () {
	    callToWebService.postCall('GetCategories', {},
			    function sucess(data) {
			        if (!data.EsError) {
			            $scope.Categories = data.Respuesta.TiposDeEgreso[1].Categorias;
			        }
			    },
			    function error(data) {
			        mostrarNotificacion.error(data.Mensaje);
			        $scope.loading = false;
			    }
			);
	};
	$scope.GetCategories();

	$scope.GetSubCategories = function () {
	    for (var x = 0; x < $scope.Categories.length; x++) {
	        if ($scope.Categories[x].Numero == $scope.defaultOpt.Numero) {
	            $scope.cuentaMayorSelect.CuentasMenores = $scope.Categories[x].SubCategorias;
	            $scope.ShowSubCategories = true;
	            $scope.CategoryChange = true;
	            break;
	        }
	    }
	};

	$scope.$watch("cuentaSelected", function () {
	    $scope.cuentaInvalida = typeof ($scope.cuentaSelected) !== 'object';
	    if ($scope.Cuentas) {
	        var matches = $filter('filter')($scope.Cuentas, $scope.cuentaSelected);
	        if (matches.length < 1) {
	            if (!$scope.NoSePuedeCrear)
	                $("#popover--nuevoCliente").removeClass('popover--hidden');
	        }
	        else {
	            $("#popover--nuevoCliente").addClass('popover--hidden');
	        }
	    }
	}, true);

	$scope.$watch("cuentaMayorSelect", function (newValue, oldValue) {
		if(newValue != oldValue)
		{
			$scope.NoSePuedeCrear = false;
			if(newValue != null){
				var objFiltrados = $filter('filter')($scope.CuentasOriginal, { ClaveCuentaMayor : newValue.ClaveCuentaMayor }, true);
				$scope.Cuentas = [];
				$scope.Cuentas = objFiltrados;
			}
			else{
				$scope.Cuentas = $scope.CuentasOriginal;
			}

			if (newValue != null && newValue.ClaveCuentaMayor == 11) {
			    $scope.ShowCategories = true;
			    if (!$scope.CategoryChange) {
			        $scope.ShowSubCategories = false;
			        $scope.defaultOpt = { Numero: 0 };
			    }
			} else {
			    $scope.ShowCategories = false;
			    $scope.ShowSubCategories = true;
			    $scope.CategoryChange = false;
			}
		}
    }, true);

    $scope.$watch("cuentaMenorSelect", function (newValue, oldValue) {
		if(newValue != oldValue)
		{
			$scope.NoSePuedeCrear = false;
			if (newValue != null) {
			    if ($scope.ShowCategories) {
			        $scope.NoSePuedeCrear = newValue.NoSePuedeCrear;
			        var objFiltrados = $filter('filter')($scope.CuentasOriginal, { Numero: $scope.cuentaMenorSelect.Numero }, true);
			        $scope.Cuentas = [];
			        $scope.Cuentas = objFiltrados;
			    } else {
			        $scope.NoSePuedeCrear = newValue.NoSePuedeCrear;
			        var objFiltrados = $filter('filter')($scope.CuentasOriginal, { ClaveCuentaMayor: $scope.cuentaMayorSelect.ClaveCuentaMayor, ClaveTipo: newValue.ClaveTipo }, true);
			        $scope.Cuentas = [];
			        $scope.Cuentas = objFiltrados;
			    }
			}
			else{
				if($scope.cuentaMayorSelect != null){
					var objFiltrados = $filter('filter')($scope.CuentasOriginal, { ClaveCuentaMayor : $scope.cuentaMayorSelect.ClaveCuentaMayor }, true);
					$scope.Cuentas = [];
					$scope.Cuentas = objFiltrados;
				}
				else{
					$scope.Cuentas = $scope.CuentasOriginal;
				}
			}
		}
    }, true);

	$scope.select = function (index) {
		$scope.selectedRow = index;
    };

    $scope.deselect = function () {
		$scope.selectedRow = -1;
    };

    $scope.selectedFiles=[];
	$scope.deleteSelectedFile = function(){
		$scope.selectedFiles=[];
	};

	$scope.onFileSelect = function($files) {
		var selFiles = $files;
        if (angular.isString(selFiles[0].name) && selFiles[0].name.length <= 80){
			$scope.selectedFiles = [];
			$scope.progress = [];
			if ($scope.upload && $scope.upload.length > 0) {
				for (var i = 0; i < $scope.upload.length; i++) {
					if ($scope.upload[i] != null) {
						$scope.upload[i].abort();
					}
				}
			}
			$scope.upload = [];
			$scope.uploadResult = [];
			$scope.selectedFiles = $files;
			$scope.dataUrls = [];
			for ( var i = 0; i < $files.length; i++) {
				var $file = $files[i];
				if (window.FileReader && $file.type.indexOf('image') > -1) {
					var fileReader = new FileReader();
					fileReader.readAsDataURL($files[i]);
					var loadFile = function(fileReader, index) {
						fileReader.onload = function(e) {}
					}(fileReader, i);
				}
				$scope.progress[i] = -1;
				if ($scope.uploadRightAway) {
					$scope.start(i);
				}
			}
		}
		else{
			mostrarNotificacion.error('El nombre del comprobante debe ser menor de 80 caracteres.')
		}
	};

	$(function(){
		$("#upload_link").on('click', function(e){
			e.preventDefault();
			$("#upload:hidden").trigger('click');
		});
	});

	$scope.SeleccionarMonedaDefault = function(){
		for(var i in $scope.Monedas) {
			if($scope.Monedas[i].CveMoneda == 1) {
				$scope.monedaSeleccionada = $scope.Monedas[i];
				break;
			}
		}
	};

	function validarFecha(){
		var fechaGasto = $('#fecha-input').val();
		if($scope.Movil)
			$scope.dateFormat = dateTools.getTimeForWCF(fechaGasto,'YYYY-MM-DD');
		else
			$scope.dateFormat = dateTools.getTimeForWCF(fechaGasto,'DD/MM/YY');
	}

	$scope.validarCargo = function(){
		if($scope.cuentaCargo != 0 && $scope.cuentaCargo != null){
			$scope.cuentaAbono = 0;
		}
		else{
			$scope.cuentaAbono = null;	
		}
	};
	$scope.validarAbono = function(){
		if($scope.cuentaAbono != 0 && $scope.cuentaAbono != null){
			$scope.cuentaCargo = 0;
		}
		else{
			$scope.cuentaCargo = null;	
		}
	};

	$scope.addPolizas = function(f){
		if(!$scope.cuentaSelected.Etiqueta){
			mostrarNotificacion.error("La cuenta selecciona no existe");
			return;
		}

		var name = $scope.cuentaSelected.Etiqueta;
		var cargo = Math.round(f.cuentaCargo.$viewValue * 100) / 100;// parseFloat(f.cuentaCargo.$viewValue);
		var abono = Math.round(f.cuentaAbono.$viewValue * 100) / 100; //parseFloat(f.cuentaAbono.$viewValue);

		$scope.pAgregadas.push({
			Nombre: $scope.cuentaSelected.Etiqueta,
			Cargo: cargo,
			Abono: abono,
			Monto: ((cargo != 0) ? cargo : abono),
			EsCargo: ((cargo != 0) ? true : false),
			ClaveTipo: $scope.cuentaSelected.ClaveTipo,
			ClaveCuenta: $scope.cuentaSelected.ClaveCuenta
		});
		$scope.Tamano = $scope.pAgregadas.length;
		$scope.LastIndex = $scope.Tamano - 1;
		$scope.TotalCargos += cargo;
		$scope.TotalAbonos += abono;

		clean();
	};

	$scope.saveFile = function(){
  		if($scope.selectedFiles.length > 0){
			var cookie = document.cookie;
			$scope.progress[0] = 0;
            $scope.upload[0] = Upload.upload({
                url: '../../../servicios/PortalServicio.svc/GuardarArchivoPoliza',
                method: 'POST',
                headers: { 'Content-Type': false },
                data: { cookie: cookie },
                file: $scope.selectedFiles[0],
                fileFormDataName: 'archivoPoliza'
            }).then(function (response) {
                if (response.data.EsError) {
                    $scope.ErrorArchivo = true;
                }
                else {
                    $scope.guardarComprobanteRespuesta = response.data.Respuesta;
                }
            }, null, function (evt) {
            });
		}
	};

	$scope.$watch("guardarComprobanteRespuesta", function (newValue, oldValue) {
		if(newValue != oldValue)
		{
			var objSend = {
				Conceptos: $scope.pAgregadas,
				ClaveMoneda: $scope.monedaSeleccionada.CveMoneda,
				Fecha: $scope.dateFormat,
				TipoDeCambio: $scope.monedaSeleccionada.Valor,
				Referencia: $('#cuentaComent').val(),
				NombreArchivo: $scope.guardarComprobanteRespuesta
			};
			callToWebService.postCall('GenerarPoliza', {poliza:objSend},
	        function sucess(data){
				if(!data.EsError){
					$scope.loading = false;
					mostrarNotificacion.info(data.Mensaje);
					$state.transitionTo('inicio.poliza.ver_poliza',{num_pol:data.Respuesta});
				}
				else
				{
					$scope.loading = false;
					mostrarNotificacion.error(data.Mensaje);
				}
	        },
	        function error(data){
	            mostrarNotificacion.error(data.Mensaje);
	            $scope.loading = false;
	        });
		}
    }, true);

    $scope.$watch("ErrorArchivo", function (newValue, oldValue) {
		if(newValue != oldValue)
		{
			$scope.loading = false;
			mostrarNotificacion.error('Error al guardar el archivo');
		}
    }, true);

    $scope.savePolizas = function () {
        
        var totalCargos = Math.round($scope.TotalCargos * 100) / 100;
        var totalAbonos = Math.round($scope.TotalAbonos * 100) / 100;

        if (totalCargos == totalAbonos) {
			$scope.loading = true;
			validarFecha();
			if($scope.selectedFiles.length > 0)
			{
				$scope.saveFile();
			}
			else
			{
				var objSend = {
					Conceptos: $scope.pAgregadas,
					ClaveMoneda: $scope.monedaSeleccionada.CveMoneda,
					Fecha: $scope.dateFormat,
					TipoDeCambio: $scope.monedaSeleccionada.Valor,
					Referencia: $('#cuentaComent').val(),
					NombreArchivo: $scope.guardarComprobanteRespuesta
				};
				callToWebService.postCall('GenerarPoliza', {poliza:objSend},
		        function sucess(data){
					if(!data.EsError){
						$scope.loading = false;
						mostrarNotificacion.info(data.Mensaje);
						$state.transitionTo('inicio.poliza.ver_poliza',{num_pol:data.Respuesta});
					}
					else
					{
						$scope.loading = false;
						mostrarNotificacion.error(data.Mensaje);
					}
		        },
		        function error(data){
		            mostrarNotificacion.error(data.Mensaje);
		            $scope.loading = false;
		        });
			}
		}
		else{
			mostrarNotificacion.error('El total de Cargos y Abonos debe ser igual');
		}
	};

	function clean(){
		$scope.cuentaSelected = null;
		$scope.cuentaAbono = null;
		$scope.cuentaCargo = null;
	}

	$scope.removePoliza = function(i){
		if(i == null){
			var selRow = $scope.pAgregadas[$scope.selectedRow];
			if(selRow.EsCargo){
				$scope.TotalCargos -= selRow.Monto;
			}
			else{
				$scope.TotalAbonos -= selRow.Monto;
			}
			$scope.pAgregadas.splice($scope.selectedRow,1);
		}
		else{
			var selRow = $scope.pAgregadas[i];
			if(selRow.EsCargo){
				$scope.TotalCargos -= selRow.Monto;
			}
			else{
				$scope.TotalAbonos -= selRow.Monto;
			}
			$scope.pAgregadas.splice(i,1);
		}

		$scope.Tamano = $scope.pAgregadas.length;
		$scope.LastIndex = $scope.Tamano - 1;
		var theads = document.getElementsByTagName('thead');
        theads[0].style.display = 'table-header-group';
        $(".actionsHeader--clientes").css("display","none");
	};

	$scope.arrowDown = function(i){
		var selRow = $scope.pAgregadas[i];
		$scope.pAgregadas.splice(i,1);
		$scope.pAgregadas.splice((i-1),0,selRow);
	};

	$scope.arrowUp = function(i){
		var selRow = $scope.pAgregadas[i];
		$scope.pAgregadas.splice(i,1);
		$scope.pAgregadas.splice((i+1),0,selRow);
	};

	$scope.displayPopup = function () {
	    var modalInstance = $uibModal.open({
          template: require('../../../../../app/views/Inicio/Poliza/NuevaCuenta_modal.html'),
	        controller: nuevaCuentaCtrl,
	        windowClass: 'modal--big',
            controllerAs: "nuevaCuentaModal",
	        resolve: {
	            ctsMayores: function () {
	                return $scope.CuentasMayores;
	            },
	            nombrecuenta: function () {
	                return $("#cuentaCuenta").val();
	            },
	            cuentamayorselect: function () {
	                return $scope.cuentaMayorSelect;
	            },
	            categoriaselect: function(){
	                return $scope.defaultOpt;
	            },
	            cuentamenorselect: function () {
	                return $scope.cuentaMenorSelect;
	            },
	            listCategories: function () {
	                return $scope.Categories;
	            },
	            cuentaOriginal: function () {
	                return $scope.CuentasOriginal;
	            }
	        }
	    });
	    modalInstance.result.then(function (data) {
	        callToWebService.postCall('ObtenerPantallaNuevaPoliza', {},
		        function sucess(data) {
		            $scope.CuentasOriginal = data.Respuesta.Cuentas;
		            $scope.Cuentas = $scope.CuentasOriginal;
		        },
		        function error(data) {
		        }
		    );
	    });

	};

	var nuevaCuentaCtrl = function ($scope, $uibModalInstance, ctsMayores, nombrecuenta, cuentamayorselect, categoriaselect, cuentamenorselect, listCategories, cuentaOriginal) {
	    $scope.CuentaNombre = nombrecuenta;
	    $scope.CuentasMayores = ctsMayores;
	    $scope.Categories = listCategories;
	    $scope.valores = {
	        CuentasAgregadas: []
	    };
	    $scope.disableSaveButton = $scope.valores.CuentasAgregadas.length < 1;

	    if (cuentamayorselect) {
	        $scope.valores.optCuentaMayor = cuentamayorselect;
	    }

	    if (cuentamayorselect.ClaveCuentaMayor == 11) {
	        $scope.valores.optCategoria = categoriaselect;
	        $scope.muestraCategorias = true;
	        $scope.muestraSubCategories = true;
	    } else {
	        $scope.muestraSubCategories = true;
	    }

	    if (cuentamenorselect)
	        $scope.valores.optCuentaMenor = cuentamenorselect;

	    $scope.GetSubCategories = function () {
	        for (var x = 0; x < $scope.Categories.length; x++) {
	            if ($scope.Categories[x].Numero == $scope.valores.optCategoria.Numero) {
	                $scope.valores.optCuentaMayor.CuentasMenores = $scope.Categories[x].SubCategorias;
	                $scope.muestraSubCategories = true;
	                break;
	            }
	        }
	    };

	    $scope.addItems = function (f) {
	        var cuentaMenorData = f.cuentaMenor.$viewValue;
	        $scope.valores.CuentasAgregadas.push({
	            Nombre: f.cuentaNombre.$viewValue,
	            NombreMenor: cuentaMenorData.Nombre,
	            NombreMayor: f.cuentaMayor.$viewValue.Nombre,
	            Numero: cuentaMenorData.Numero,
	            ClaveTipo: cuentaMenorData.ClaveTipo
	        });
	        $("#cuentaNombre").val('');
	        f.cuentaNombre.$setValidity('required', false);
	        $scope.disableSaveButton = $scope.valores.CuentasAgregadas.length < 1;
	    };

	    $scope.deleteItems = function (i) {
	        $scope.valores.CuentasAgregadas.splice(i, 1);
	        $scope.disableSaveButton = $scope.valores.CuentasAgregadas.length < 1;
	    };

	    $scope.updateCuenta = function (f) {
	        f.cuentaMenor.$setValidity('required', false);
	        $scope.NoSePuedeCrear = false;
	        if ($scope.valores.optCuentaMayor.ClaveCuentaMayor == 11) {
	            $scope.muestraCategorias = true;
	            $scope.muestraSubCategories = false;
	            $scope.valores.optCategoria = { Numero: 0 };
	        } else {
	            $scope.muestraCategorias = false;
	            $scope.muestraSubCategories = true;
	        }
	    };

	    $scope.update = function (f) {
	        $scope.NoSePuedeCrear = f.cuentaMenor.$viewValue.NoSePuedeCrear;
	    };

	    $scope.saveChanges = function () {
	        $scope.disableSaveButton = true;
	        callToWebService.postCall('AgregarCuentas', { cuentas: $scope.valores.CuentasAgregadas },
			    function sucess(data) {
			        if (!data.EsError) {
			            $uibModalInstance.close(data);
			        }
			        else {
			            $scope.alert = [];
			            $scope.alert.push({ type: 'error', msg: data.Mensaje });
			        }
			    },
			    function error(data) {
			        $scope.alert = [];
			        $scope.alert.push({ type: 'error', msg: data.Mensaje });
			    }
			);
	    };

	    $scope.closeModalAlert = function (i) {
	        $scope.alert.splice(i, 1);
	    };

	    $scope.closeModal = function () {
	        $uibModalInstance.dismiss();
	    };
	};
});
